import Store from 'ember-data/store'
export default Store

declare module '@ember/service' {
  interface Registry {
    store: Store
  }
}
